export default __webpack_public_path__ + "static/media/icon_translate.f6243808.svg";